import styled from '@emotion/styled';
import { SvgIcon, SvgNames, tokens } from '@sunrun/experience-ui-components';
import type { ReactNode } from 'react';
// eslint-disable-next-line import/no-restricted-paths
import { InfoPopover } from 'components/atoms/InfoPopover';

type InfoIconPopoverProps = {
  content: ReactNode;
  contentAriaLabel: string;
  triggerAriaLabel: string;
  contentTestId?: string;
  iconSize?: number;
  iconColor?: string;
};

const InfoIconPopover = ({
  content,
  contentAriaLabel,
  triggerAriaLabel,
  contentTestId,
  iconSize = 18,
  iconColor = tokens.CHARGEBLUE_30,
}: InfoIconPopoverProps) => (
  <InfoPopover
    content={content}
    contentAriaLabel={contentAriaLabel}
    contentTestId={contentTestId}>
    <InfoTriggerButton type="button" aria-label={triggerAriaLabel}>
      <SvgIcon
        name={SvgNames.InfoOutline}
        width={iconSize}
        height={iconSize}
        color={iconColor}
      />
    </InfoTriggerButton>
  </InfoPopover>
);

const InfoTriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;
  border-radius: 50%;
  flex-shrink: 0;

  &:focus-visible {
    outline: 2px solid ${tokens.HEROBLUE_50};
    outline-offset: 2px;
  }
`;

export { InfoIconPopover };
